import usePaginatedData from './use-paginated-data';
import { APIApartmentItemLikable } from 'api/types';
import { transformApartmentItem } from 'api/transformers';
import { ApartmentListItemProps } from 'components/apartment-list-item';
import useApartmentsSortQuery from './use-apartment-sort-query';
import useFilterQuerySecondary from './use-filter-query-secondary';

export type APIApartmentDealsRes = {
  items: APIApartmentItemLikable[];
  count: number;
};

export type ApartmentDeal = Omit<ApartmentListItemProps, 'className' | 'icon'> & {
  id: number;
  availabilityStatus: { key: string; translation: string };
};

const useApartmentListSecondary = () => {
  const filter = useFilterQuerySecondary();
  const sortByField = useApartmentsSortQuery();
  const result = usePaginatedData<APIApartmentDealsRes, ApartmentDeal>(
    '/facilities/facility-list',
    'post',
    // @ts-ignore
    ({ items, count }) => {
      const apartments = items.map(transformApartmentItem);
      return { items: apartments, count };
    },
    sortByField?.field && sortByField?.direction
      ? { filter: { ...filter, marketType: 'Secondary' }, sortByField }
      : { filter: { ...filter, marketType: 'Secondary' } },
  );
  return result;
};

export default useApartmentListSecondary;
